export class Gallery {
  constructor(id = '', name = '', order = [], suffix = '') {
    this.id = id;
    this.name = name;
    this.order = order;
    this.suffix = suffix;
  }
}

export default Gallery;




// WEBPACK FOOTER //
// ./src/models/gallery.js